import {useRef, useState} from "react";
import SvgChevronDown from "../svg/SvgChevronDown";
import useOutsideClick from "../hooks/useOutsideClick";
import SvgCrossRounded from "../svg/SvgCrossRounded";

export default function Select({
                                   label,
                                   options,
                                   onChange,
                                   onClear,
                                   selected = null,
                                   error = false,
                                   className = '',
                                   ...rest
                               }) {
    const [activeDropdown, setActiveDropdown] = useState(false);
    const selectRef = useRef();

    const handleClick = () => setActiveDropdown(!activeDropdown);

    useOutsideClick(selectRef, () => setActiveDropdown(false));

    return (
        <div
            className={`relative ${activeDropdown ? 'z-20' : 'z-10 md:z-20'} text-sm min-w-[190px] select-none will-change-transform ${className}`}
            onClick={handleClick}
            ref={selectRef}
            {...rest}
        >
            <div
                className={`relative z-20 w-full min-w-[195px] inline-flex justify-between items-center border pl-4 pr-5 gap-4 rounded-full transition-all duration-300 cursor-pointer py-3 focus:border-black focus:outline-none ${selected ? 'bg-black text-white border-black' : (activeDropdown ? 'bg-white text-black/50 border-black/50' : 'bg-white text-black/50 border-[#eee] mouse-hover:border-black/50')}`}>

                <div
                    className={`w-5 transition-opacity duration-300 text-white ${selected && onClear ? '' : 'pointer-events-none opacity-0'}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        onClear();
                    }}
                >
                    <SvgCrossRounded className="pointer-events-none"/>
                </div>

                {!selected ? label : options.find(({value}) => value === selected).label}

                <div
                    className={`w-2 transition-transform duration-200 ${activeDropdown ? 'rotate-180' : ''}`}>
                    <SvgChevronDown/>
                </div>
            </div>

            <div
                className={`absolute top-[23px] rounded-bl-[22px] rounded-br-[22px] left-1/2 -translate-x-1/2 w-full pt-[25px] pb-[6px] min-w-max bg-[#fcfcfc] text-white border border-[#eee] transition-all duration-300 z-10 ${activeDropdown ? '' : '-translate-y-[30px] opacity-0 pointer-events-none'}`}
            >
                {options.map(({label, value}, key) => {
                    return (
                        <div key={`Option: ${key}`}
                             onClick={() => onChange(value)}
                             className="option text-black/40 mouse-hover:text-black transition-colors duration-300 py-2 cursor-pointer"
                        >
                            {label}
                        </div>
                    )
                })}
            </div>

        </div>
    )
}
